export default __webpack_public_path__ + "static/media/erpReady.a66d1e25.png";